import React from 'react';
import './InputText.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';
import { classNames } from '../../functions/classNames';

const InputText = (props, context) => (
  <div className={classNames('InputText', props.error ? 'hasError' : '')} style={props.style}>
    <div className="inputLabel">
      <span>{getLabel(context.locale, props.label)}</span>
      {props.required ? <span className="required">*</span> : ''}
    </div>
    <input
      type="text"
      name={props.name}
      value={props.value}
      onChange={props.handleChange}
      placeholder={props.placeholder ? props.placeholder : ''}
      autoComplete="off"
      disabled={props.disabled}
      autoFocus={props.autoFocus}
    />
  </div>
);

InputText.contextTypes = {
  locale: PropTypes.string,
};

export default InputText;



// WEBPACK FOOTER //
// ./src/main/components/input/InputText.js